import { MutableRefObject, useEffect, useRef } from "react"

export function usePreviousTyped<T>(value: T, initialValue?: T): MutableRefObject<T | undefined>["current"] {
    const ref = useRef<T | undefined>(initialValue)
    useEffect(() => {
        ref.current = value
    }, [value])
    return ref.current
}
